import { render, staticRenderFns } from "./TypingMessage.vue?vue&type=template&id=0848dcd8&scoped=true&"
import script from "./TypingMessage.vue?vue&type=script&lang=js&"
export * from "./TypingMessage.vue?vue&type=script&lang=js&"
import style0 from "./TypingMessage.vue?vue&type=style&index=0&id=0848dcd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848dcd8",
  null
  
)

export default component.exports